import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import { useThemeContext } from '../../context/ThemeContext';

const ThemeToggleButton = () => {
  const theme = useTheme();
  const { updateTheme } = useThemeContext();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
      <IconButton
        onClick={() => updateTheme(isDark ? 'light' : 'dark')}
        aria-label="Toggle color theme"
        size="small"
        sx={{
          color: 'text.primary',
          bgcolor: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(15,23,42,0.05)',
          '&:hover': { bgcolor: isDark ? 'rgba(255,255,255,0.16)' : 'rgba(15,23,42,0.1)' },
        }}
      >
        {isDark ? <LightModeOutlinedIcon fontSize="small" /> : <DarkModeOutlinedIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggleButton;
